import Hero from "../components/Hero";
import StatsStrip from "../components/StatsStrip";
import Services from "../components/Services";
import WhyUs from "../components/WhyUs";
import Process from "../components/Process";
import DataAlive from "../components/DataAlive";
import Industries from "../components/Industries";
import CaseStudy from "../components/CaseStudy";
import LeadForm from "../components/LeadForm";
import SampleReport from "../components/SampleReport";
import FinalCTA from "../components/FinalCTA";

export default function Home() {
    return (
        <main data-testid="home-page">
            <Hero />
            <StatsStrip />
            <Services />
            <WhyUs />
            <Process />
            <DataAlive />
            <Industries />
            <CaseStudy />
            <LeadForm />
            <SampleReport />
            <FinalCTA />
        </main>
    );
}
